import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, submit, isDirty } from 'redux-form';
import { localize } from 'react-localize-redux';
import { formatPhone } from 'helpers/Formatter';
import { CSSTransitionGroup } from 'react-transition-group';

import FlatButton from 'material-ui/FlatButton';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';

import {
  createEmergencyContact,
  deleteEmergencyContact,
  editEmergencyContact,
} from 'actions/tenantProfileActions';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import EmergencyContactForm from './EmergencyContactForm';

let AddEmergencyContactForm = reduxForm({
  form: 'add_emergency_contact',
})(EmergencyContactForm);

let EditEmergencyContactForm = reduxForm({
  form: 'edit_emergency_contact',
  enableReinitialize: true,
})(EmergencyContactForm);

export default connect(
  store => {
    return {
      emergencyContacts: store.tenantProfile.emergencyContacts,
      isEditFormDirty: isDirty('edit_emergency_contact')(store),
    };
  },
  {
    createEmergencyContact,
    deleteEmergencyContact,
    editEmergencyContact,
    addEmergencyContactSubmitButton: () => submit('add_emergency_contact'),
    editEmergencyContactSubmitButton: () => submit('edit_emergency_contact'),
  }
)(
  localize()(
    class LandlordReference extends Component {
      constructor(props) {
        super(props);
        this.state = {
          openAddForm: false,
          openDeleteDialog: false,
          openEditDialog: false,
        };
      }

      toggleDeleteDialog = id => {
        this.setState({
          openDeleteDialog: !this.state.openDeleteDialog,
          referenceId: id,
        });
      };

      toggleEditDialog = emergencyContact => {
        this.setState({
          openEditDialog: !this.state.openEditDialog,
          emergencyContact: emergencyContact,
        });
      };

      toggleAddForm = () => {
        this.setState({
          openAddForm: !this.state.openAddForm,
        });
      };

      deleteEmegencyContact = () => {
        this.props.deleteEmergencyContact(this.state.referenceId);
        this.setState({ openDeleteDialog: false, referenceId: null });
      };

      handleAddSubmit = values => {
        this.props.createEmergencyContact(values);
        this.setState({
          openAddForm: false,
        });
      };

      handleEditSubmit = values => {
        this.props.editEmergencyContact(values, this.state.emergencyContact.id);
        this.setState({
          openEditDialog: false,
        });
      };

      render() {
        const emergencyContacts = this.props.emergencyContacts;
        const subMenuHeader = this.props.sub_menu_header_styling;

        const style = {
          row: {
            padding: '0 15px',
            marginTop: '30px',
          },
          header: {
            color: '#4e4e4e',
            fontSize: '18px',
            marginBottom: '0',
            marginTop: '0',
          },
          subHeader: {
            marginTop: '5px',
            marginBottom: 0,
            color: '#6F6F6F',
            textAlign: 'justify',
            overflowWrap: 'break-word',
          },
          buttonContainer: {
            padding: '30px 15px 10px 15px',
            marginTop: '-10px',
            textAlign: 'center',
          },
          button: {
            backgroundColor: AccentColor(),
            color: '#fff',
          },
          paddingLeft: {
            padding: '15px 0px 0 0',
            textAlign: 'left',
          },
          titleContentStyle: {
            borderBottom: '0px solid #e0e0e0',
            padding: '20px 20px 5px 20px',
            textAlign: 'center',
            color: '#4e4e4e',
          },
          customContentStyle: {
            maxWidth: '400px',
            width: '95%',
          },
          bodyContentStyle: {
            padding: '10px 20px 20px 20px',
            textAlign: 'center',
          },
          deletebodyContentStyle: {
            padding: '20px 5px 0px 5px',
            textAlign: 'center',
          },
          deleteButton: { marginLeft: '20px' },
          outlinedButton: { borderWidth: '2px' },
          closeButton: { color: '#6F6F6F' },
          saveButton: {
            backgroundColor: AccentColor(),
            color: '#fff',
          },
          deleteContactHeading: { textAlign: 'center', margin: 0 },
          block: { display: 'block' },
          confirmNoButton: {
            float: 'left',
            backgroundColor: 'white',
            color: AccentColor(),
          },
          confirmYesButton: {
            float: 'right',
            backgroundColor: AccentColor(),
            color: 'white',
          },
          editContanctHeading: { textAlign: 'center', margin: 0 },
          editContactForm: { marginTop: '-30px' },
          accent: { color: AccentColor() },
          submitButton: {
            float: 'right',
            color: 'white',
            backgroundColor: !this.props.isEditFormDirty ? colors.LIGHT_GRAY : AccentColor(),
          },
        };

        const showAddEmergencyContact =
          this.state.openAddForm === false &&
          (!hostIsBoardwalk() || emergencyContacts.length === 0);

        let tenantEmergencyContacts = null;

        if (emergencyContacts && emergencyContacts.length !== 0) {
          tenantEmergencyContacts = Object.keys(emergencyContacts).map(key => (
            <div key={key} className="row" style={style.row}>
              <div className="wrapper">
                <h5 style={style.header}>{emergencyContacts[key].full_name}</h5>
                <h5 style={style.subHeader}>{emergencyContacts[key].email}</h5>
                <h5 style={style.subHeader}>{formatPhone(emergencyContacts[key].phone_number)}</h5>
                {emergencyContacts[key].relationship_code && (
                  <h5 style={style.subHeader}>
                    {this.props.translate(
                      `tenantPortal.emergencyContactRelationship.${emergencyContacts[key]
                        .relationship_code}`
                    )}
                  </h5>
                )}
                <div className="row" style={style.paddingLeft}>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      this.toggleEditDialog(emergencyContacts[key]);
                    }}
                  >
                    {' '}
                    {this.props.translate('edit')}{' '}
                  </button>
                  <button
                    type="button"
                    className="link-button"
                    style={style.deleteButton}
                    onClick={() => {
                      this.toggleDeleteDialog(emergencyContacts[key].id);
                    }}
                  >
                    {' '}
                    {this.props.translate('delete')}{' '}
                  </button>
                </div>
              </div>
            </div>
          ));
        } else {
          tenantEmergencyContacts = (
            <div className="small-message">
              <small>{this.props.translate('clickToAddEmergencyContact')}.</small>
            </div>
          );
        }

        return (
          <div>
            <div className="row" style={subMenuHeader}>
              <h5> {this.props.translate('emergencyContactInformation')}</h5>
            </div>

            {tenantEmergencyContacts}

            <CSSTransitionGroup
              transitionName="add_landlord_emergency_contact"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this.state.openAddForm && (
                <div>
                  <AddEmergencyContactForm onSubmit={this.handleAddSubmit} />
                  <div className="row">
                    <div style={style.buttonContainer}>
                      <FlatButton
                        label={this.props.translate('close')}
                        primary={true}
                        style={style.closeButton}
                        onClick={this.toggleAddForm}
                      />
                      <FlatButton
                        label={this.props.translate('save')}
                        primary={true}
                        onClick={this.props.addEmergencyContactSubmitButton}
                        style={style.saveButton}
                      />
                    </div>
                  </div>
                </div>
              )}
            </CSSTransitionGroup>

            {showAddEmergencyContact && (
              <div className="row" id="add_landlord_button" style={style.buttonContainer}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={this.toggleAddForm}
                  style={style.outlinedButton}
                >
                  {this.props.translate('addEmergencyContact')}
                </Button>
              </div>
            )}

            <Dialog
              disableBackdropClick
              fullScreen={this.props.fullScreen}
              open={this.state.openDeleteDialog}
              onClose={this.toggleDeleteDialog}
              aria-labelledby="edit-lead"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-amenity">
                <h3 style={style.deleteContactHeading}>
                  {this.props.translate('deleteEmergencyContact')}
                </h3>
              </DialogTitle>
              <DialogContent>
                {this.props.translate('deleteEmergencyContact.areYouSure')}
              </DialogContent>
              <DialogActions style={style.block}>
                <FlatButton
                  label={this.props.translate('request_type.no')}
                  style={style.confirmNoButton}
                  onClick={this.toggleDeleteDialog}
                />
                <FlatButton
                  label={this.props.translate('request_type.yes')}
                  style={style.confirmYesButton}
                  onClick={this.deleteEmegencyContact}
                />
              </DialogActions>
            </Dialog>

            <Dialog
              disableBackdropClick
              fullScreen={this.props.fullScreen}
              open={this.state.openEditDialog}
              onClose={this.toggleEditDialog}
              aria-labelledby="edit-lead"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-amenity">
                <h3 style={style.editContanctHeading}>
                  {this.props.translate('editEmergencyContact')}
                </h3>
              </DialogTitle>
              <DialogContent>
                <div className="row" style={style.editContactForm}>
                  <EditEmergencyContactForm
                    onSubmit={this.handleEditSubmit}
                    initialValues={this.state.emergencyContact}
                  />
                </div>
              </DialogContent>
              <DialogActions style={style.block}>
                <FlatButton
                  id="close-button"
                  label={this.props.translate('close')}
                  style={style.accent}
                  onClick={this.toggleEditDialog}
                />
                <FlatButton
                  label={this.props.translate('save')}
                  id="submit-button"
                  style={style.submitButton}
                  keyboardFocused
                  disabled={!this.props.isEditFormDirty}
                  onClick={this.props.editEmergencyContactSubmitButton}
                />
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    }
  )
);
